import { render, staticRenderFns } from "./JourneyDetailSubmit.vue?vue&type=template&id=9b727d42&scoped=true"
import script from "./JourneyDetailSubmit.vue?vue&type=script&lang=js"
export * from "./JourneyDetailSubmit.vue?vue&type=script&lang=js"
import style0 from "./JourneyDetailSubmit.vue?vue&type=style&index=0&id=9b727d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b727d42",
  null
  
)

export default component.exports